import Register from "components/Register"
import Head from "components/Head"
import Logo from "components/Logo"

import { useEffect } from "react"
import { useRouter } from "next/router"

import useUser from "hooks/useUser"
import { useSelector } from "react-redux"
import { selectUsersBlog, getLoggedInUsersBlog } from "features/blogSlice"
import { useAppDispatch } from "store"

export default function RegisterPage() {
  const router = useRouter()
  const user = useUser()
  const dispatch = useAppDispatch()
  const blog = useSelector(selectUsersBlog)

  useEffect(() => {
    if (!user?.id) return
    console.log("Fetching logged-in users blog from register page")
    dispatch(getLoggedInUsersBlog())
  }, [dispatch, user.id])

  // Redirect the user appropriately.
  // (They may have connected their wallet but already had an account)
  useEffect(() => {
    if (!blog.id) return

    if (blog.needToSetup) {
      console.log("Pushing to setup")
      router.push("/setup")
      return
    }

    console.log("Pushing to notes")

    router.push("/notes")
  }, [blog.id, blog.needToSetup, router])

  return (
    <div>
      <div className="flex flex-col justify-center min-h-screen py-12 bg-gray-50 sm:px-6 lg:px-8">
        <Head
          title="Register | Paragraph"
          description="Register for a Paragraph account and start your blog & newsletter"
          fullUrl="https://paragraph.xyz/register"
        />
        <Register
          header={
            <div className="sm:mx-auto sm:w-full sm:max-w-md">
              <div className="flex content-center">
                <Logo className="h-12 m-auto" />
              </div>
              <h2 className="mt-6 text-3xl font-extrabold text-center text-gray-900">
                Register for an account
              </h2>
              <p className="mt-2 text-sm text-center text-gray-600">
                Get started in seconds. Register using your email, or connect
                your crypto wallet. (You can always connect both to your account
                later).
              </p>
            </div>
          }
        />
      </div>
    </div>
  )
}
